import React from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import AthleteProfileComponent from "../../Components/AthleteProfileComponent/AthleteProfileComponent";

const AthleteProfile = () => {
  return (
    <div>
      <Header />
      <AthleteProfileComponent />
      <Footer />
    </div>
  );
};

export default AthleteProfile;
